var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotSupported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 96,
    viewBox: "0 0 81 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 94.5H19C17.6193 94.5 16.5 93.3807 16.5 92V21C16.5 19.6193 17.6193 18.5 19 18.5H61.3431C62.0062 18.5 62.6421 18.7634 63.1109 19.2322L78.7678 34.8891C79.2366 35.3579 79.5 35.9938 79.5 36.6569V92C79.5 93.3807 78.3807 94.5 77 94.5Z",
    stroke: "#2F403C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36H80L62 18V36Z",
    fill: "#2F403C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D3F3C7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 12,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6C11.3727 6 6 11.3727 6 18C6 24.6273 11.3727 30 18 30C24.6273 30 30 24.6273 30 18C30 11.3727 24.6273 6 18 6ZM18 27.8182C12.5727 27.8182 8.18182 23.4273 8.18182 18C8.18182 12.5727 12.5727 8.18182 18 8.18182C23.4273 8.18182 27.8182 12.5727 27.8182 18C27.8182 23.4273 23.4273 27.8182 18 27.8182Z",
    fill: "#2F403C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.091 12H16.9092V20.1818H19.091V12Z",
    fill: "#2F403C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.091 21.8182H16.9092V24H19.091V21.8182Z",
    fill: "#2F403C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 28,
    y: 49,
    width: 40,
    height: 6,
    fill: "#2F403C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 28,
    y: 57,
    width: 40,
    height: 6,
    fill: "#2F403C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 28,
    y: 65,
    width: 40,
    height: 6,
    fill: "#2F403C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 56,
    y: 73,
    width: 12,
    height: 6,
    fill: "#2F403C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSupported);
export default __webpack_public_path__ + "static/media/NotSupported.1ef355eac0caa9ced366be405c24c5b7.svg";
export { ForwardRef as ReactComponent };